import { PURCHASE_QUANTITY_MAX } from '../constants'

const pdp_buy_box = {

  init: () => {
    subscription_toggle();
    quantity_selector();
    select_variant_on_load();
    handleVariantSwatchKingLoad();

    function subscription_toggle() {
      $('select#productSelect').on('change', function() {
        update_id();
      });

      $('input[name="purchaseTypeToggle"]').on('change', function() {
        update_id();
      });

      function update_id() {
        if ($('input#switch_sns').is(':checked')) {
          var id = $('select#productSelect').find(":selected").attr('prod-variant-subscription-id');
          if($('.buy-box-subscription-property').length>0) {
            $('.buy-box-subscription-property').removeAttr("disabled");
          }
          if( $('.subscription-frequency-container')>0) {
            $('.subscription-frequency-container').removeClass('sr-hidden')
          }
        }
        else {
          var id = $('select#productSelect').find(":selected").attr('prod-variant-id');
          var params = new URLSearchParams(window.location.search)
          params.set('variant', id);
          var newRelativePathQuery = window.location.pathname + '?' + params.toString();
          history.pushState(null, '', newRelativePathQuery);
          if( $('.buy-box-subscription-property').length>0) {
            $('.buy-box-subscription-property').attr("disabled", true);
          }
          if( $('.subscription-frequency-container').length>0) {
            $('.subscription-frequency-container').addClass('sr-hidden')
          }
          updateBasketfulLink(id)
          hidePackSwatch()
        }
        $('#product-add-id').attr('value', id);
      }
    }

    function quantity_selector() {
      console.log("PLUS/MINUS INIT ----");
      $(document).on('click', '.pdp-qty-minus', function() {
        var $current_value = parseInt($(this).parent().find('.pdp-qty-input').val());
        if ($current_value > 1) {
          var $new_value = $current_value - 1;
          $(this).parent().find('.pdp-qty-input').val($new_value);
          $(document).find('.js-pdp-qty-selector-warning').hide()
        }
      });
      $(document).on('click', '.pdp-qty-plus', function() {
        var $current_value = parseInt($(this).parent().find('.pdp-qty-input').val());
        if ($current_value < PURCHASE_QUANTITY_MAX) {
          var $new_value = $current_value + 1;
          $(this).parent().find('.pdp-qty-input').val($new_value);
        }
        else if ($current_value === PURCHASE_QUANTITY_MAX) {
          $(document).find('.js-pdp-qty-selector-warning').show()
        }
      });
    }

    // On load, make sure to select the correct variant id in the select if on a subscription pdp
    function select_variant_on_load() {
      $(function() {
        var params = new URLSearchParams(window.location.search);
        var variantSelectElement = $('select#productSelect')
        if(variantSelectElement && params.has('variant')) {
          variantSelectElement.val(params.get('variant')).change()
        }
      })
    }

    // Updates the Basketful barcode when variant ID changes.
    function updateBasketfulLink(id) {
      const productData = window.productData
      if ((!id || !productData) && productData[id]) return
      const el = document.querySelector('.js-basketful-link');
      if(el!== null) {
        el.setAttribute('data-basketful-product-locator-upc', productData[id]);
      }
    }

    // Hides Pack swatch if 'variant.metafields.pdp_variant.hide_variant === true'
    function hidePackSwatch() {
      if(window.theme.pdp!= undefined) {
        const {hideVariantPack} = window.theme.pdp;

        if (document.querySelectorAll('.variant-radios__input') != null) {

        }
        if (document.querySelector('[swatch-option="option1"].swatch-selected') != null) {
          console.log(`got here - hideVariantPack: ${hideVariantPack}`);
          const activeFlavor = document.querySelector('[swatch-option="option1"].swatch-selected').dataset.value
          console.log(`got here - activeFlavor: ${hideVariantPack}`);
          if (!hideVariantPack || !activeFlavor || hideVariantPack[activeFlavor].length === 0) return
          document.querySelectorAll('[swatch-option="option2"].swatch-button').forEach((el) => {
            if (hideVariantPack[activeFlavor].includes(el.dataset.value))
              el.parentNode.style.display = 'none'
          })
        }
      }
    }

    function handleVariantSwatchKingLoad() {
      const intervalId = setInterval(() => {
        if (document.querySelector('variant-swatch-king')) {
          clearInterval(intervalId)
          hidePackSwatch()
        }
      }, 100)
    }
  }

};
export default pdp_buy_box;
